export const waitingModalMessageTypes = {
  checkingPrices: "checkingPrices",
  processingPayment: "processingPayment",
};
